import React from "react";
//#region types
import { CurrencyEnums } from "models/enums";
import { IconDefinitionConstants, HTMLConstants } from "utils/constants";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { Icon, SimpleTooltip } from "components/common";
import { Grid, Portal } from "@mui/material";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

interface RevenueReportingDifferenceFooterProps {
  total: number;
  balanced: boolean;
  show: boolean;
}

const RevenueReportingDifferenceFooter: React.FC<RevenueReportingDifferenceFooterProps> = ({
  total,
  balanced,
  show,
}) => {
  const footerMount = document.getElementById(HTMLConstants.DialogFooterPortalId);

  if (!footerMount || !show) {
    return null;
  }

  return (
    <Portal container={footerMount}>
      <Grid container alignItems="center" wrap="nowrap" className={cssExports.revenueReportingCreateFooter}>
        <label className={cssExports.footerLabel}>
          {`${LocalizationHelperInstance.getFormattedMessage(TranslationKeys.RevenueReporting.Difference)}:`}
        </label>
        <SimpleTooltip
          text={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.RevenueReporting.DifferenceBetweenSums)}
        >
          <label className={clsx(cssExports.footerValue, balanced ? "" : cssExports.danger)}>
            {`${total < 0 ? "-" : ""}${LocalizationHelperInstance.getFormattedCurrency(
              Math.abs(total),
              CurrencyEnums.CurrencyCode.SEK
            )}`}
          </label>
        </SimpleTooltip>
        <Icon
          icon={balanced ? IconDefinitionConstants.WCheck : IconDefinitionConstants.WExclamation}
          className={clsx(cssExports.footerIcon, balanced ? "" : cssExports.danger)}
        />
      </Grid>
    </Portal>
  );
};

export default RevenueReportingDifferenceFooter;
